import clsx from "clsx";
import { Button as RACButton } from "react-aria-components";
import { buttonStyles } from "./Button.recipe";
import { ButtonProps } from "./types";

export const Button = ({
  appearance,
  children,
  className,
  fullWidth,
  noWrap,
  size,
  ...props
}: ButtonProps) => (
  <RACButton
    {...props}
    className={clsx(
      buttonStyles({ appearance, fullWidth, noWrap, size }),
      className,
    )}
  >
    {children}
  </RACButton>
);
